import React from 'react';
import { Link } from 'react-router-dom';
import { CITY_DATA } from '../data/cityData';

const CITY_IDS = Object.keys(CITY_DATA);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white mt-20" data-testid="site-footer">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">
              <span className="text-[#5c0701]">CT</span>
              <span className="text-[#3a87fe]">Home</span>
              <span>Remodels</span>
            </h3>
            <p className="text-gray-400 mb-4">
              Visser General Construction LLC
            </p>
            <p className="text-gray-400 text-sm">
              Accomplish the best quality work possible
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-lg">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">
                  CT Remodel News
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#3a87fe] hover:text-white font-semibold transition-colors duration-200">
                  Get Free Estimate
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4 text-lg">Our Services</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services/kitchen-remodeling" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">Kitchen Remodeling</Link></li>
              <li><Link to="/services/bathroom-remodeling" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">Bathroom Remodeling</Link></li>
              <li><Link to="/services/deck-building" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">Trex Decking</Link></li>
              <li><Link to="/services/basement-finishing" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">Basement Finishing</Link></li>
              <li><Link to="/services/vinyl-siding" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">Vinyl Siding</Link></li>
              <li><Link to="/services/window-replacement" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">Window Replacement</Link></li>
              <li><Link to="/services/custom-furniture" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">Custom Furniture & Aquariums</Link></li>
              <li><Link to="/services/home-maintenance" className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200">Home Maintenance</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4 text-lg">Contact Us</h4>
            <div className="space-y-3 text-gray-400">
              <p>
                <strong className="text-white">Address:</strong><br />
                42 Gay St<br />
                Meriden, CT
              </p>
              <p>
                <strong className="text-white">Phone:</strong><br />
                <a href="tel:2036043202" className="hover:text-[#3a87fe] transition-colors duration-200" data-testid="footer-phone">
                  (203) 604-3202
                </a>
              </p>
              <p>
                <strong className="text-white">Hours:</strong><br />
                Mon-Fri: 5:00 AM - 5:30 PM
              </p>
              <p className="mt-3 text-[#3a87fe] font-semibold text-sm">
                Fully Licensed & Insured<br />
                Up to $1 Million Liability<br />
                HIC Lic# HIC.0698385
              </p>
            </div>
          </div>
        </div>

        {/* Service Areas - Geo Landing Pages */}
        <div className="border-t border-gray-800 mt-10 pt-8" data-testid="footer-service-areas">
          <h4 className="font-semibold mb-5 text-lg text-center">
            <svg className="w-5 h-5 inline-block mr-2 text-[#3a87fe] align-text-bottom" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
            </svg>
            Service Areas in Connecticut
          </h4>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-4 gap-y-2 text-sm">
            {CITY_IDS.map((cityId) => {
              const city = CITY_DATA[cityId];
              return (
                <Link
                  key={cityId}
                  to={`/locations/${cityId}`}
                  className="text-gray-400 hover:text-[#3a87fe] transition-colors duration-200 py-1"
                  data-testid={`footer-city-${cityId}`}
                >
                  {city.name}, CT
                </Link>
              );
            })}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>
            &copy; {currentYear} Visser General Construction LLC. All rights reserved. Fully Licensed & Insured up to $1M Liability. HIC Lic# HIC.0698385
          </p>
          <p className="mt-2">
            Serving Connecticut homeowners within 40 miles of Meriden, CT
          </p>
          <div className="mt-3 flex justify-center gap-4">
            <Link to="/terms" className="hover:text-[#3a87fe] transition-colors duration-200">Terms of Service</Link>
            <span>|</span>
            <Link to="/privacy" className="hover:text-[#3a87fe] transition-colors duration-200">Privacy Policy</Link>
            <span>|</span>
            <Link to="/sms-policy" className="hover:text-[#3a87fe] transition-colors duration-200">SMS Policy</Link>
            <span>|</span>
            <Link to="/admin/login" className="text-gray-600 hover:text-gray-400 transition-colors duration-200" data-testid="footer-admin-login">Site Admin</Link>
          </div>
          <p className="mt-4 text-gray-500 text-xs">
            Web design, Hosting, and SEO by{' '}
            <a href="https://web-techservices.com" target="_blank" rel="noopener noreferrer" className="text-[#3a87fe] hover:underline">
              Web-Techservices.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
